import React, { useContext } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../components/Icon";
import Actions from "../../../components/Actions";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { deleteCategory, deleteCollection } from '../../../Firebase/firebaseDatabase'
import { GlobalState } from "../../../App";


const Control = ({ className, visibleActions, setVisibleActions, up, data, setIsActionComplete, setIsClicked }) => {

  const theme = useTheme();
  const matches1022 = useMediaQuery(theme.breakpoints.down(1023));


  const actions = [
    {
      title: "Edit product",
      icon: "edit",
      action: () => { window.location.href = `/collection/${data?.id}/edit` },
    },
    {
      title: "Delete forever",
      icon: "trash",
      action: () => {
        setIsClicked(true);
        deleteCollection(data?.id).then((res) => {
          if (res === true) {
            setIsActionComplete(true)
            setIsClicked(false)
          }
        })
      },
    },
  ];

  const delete_actions = [
    {
      title: "Yes",
      icon: "check",
      action: () => {
        setIsClicked(true);
        deleteCollection(data?.id).then((res) => {
          if (res === true) {
            setIsActionComplete(true)
            setIsClicked(false)
          }
        })
      },
    },
    {
      title: "No",
      icon: "close",
      action: () => {
      },
    }
  ]
  return (
    <div className={cn(styles.control, className)}>
      <button onClick={() => {
        window.location.href = `/collection/${data?.id}/edit`
      }} className={styles.button}>
        <Icon name="edit" size="20" />
      </button>

      {
        matches1022 ?
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            classActionsBody={styles.actionsBody}
            classActionsOption={styles.actionsOption}
            items={actions}
            visible={visibleActions}
            setVisible={setVisibleActions}
            up={up}
          />
          :

          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            classActionsBody={styles.actionsBody}
            // classActionsOption={styles.actionsOption}
            icon="trash"
            items={delete_actions}
            data={data}
            visible={visibleActions}
            setVisible={setVisibleActions}
            up={up}
          />
      }

    </div>
  );
};

export default Control;
